import { makeStyles } from "tss-react/mui"
import { DialogContent, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { StandardDialog } from "../../../../dialogs/StandardDialog"

const useStyles = makeStyles()((theme) => ({
    dialogContent: {
        padding: "2.5rem",
        paddingTop: "0",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        color: theme.palette.tailwind.slate[950],
        textAlign: "center",
    },
}))

type EmptyPriceListsDialogProps = Readonly<{
    onClose: () => void
}>

export function EmptyPriceListsDialog({ onClose }: EmptyPriceListsDialogProps) {
    const { classes } = useStyles()

    return (
        <StandardDialog
            dialogTitle={
                <LocalizedStrict id="create-order-empty-price-list-dialog">
                    <>No pricelist available</>
                </LocalizedStrict>
            }
            open
            onClose={onClose}
            maxWidthProp="md"
            scroll="body"
        >
            <DialogContent className={classes.dialogContent}>
                <LocalizedStrict id="create-order-empty-price-list-dialog-body">
                    <Typography variant="body1">Currently there are no pricelist available</Typography>
                </LocalizedStrict>
                <LocalizedStrict id="create-order-empty-price-list-dialog-body-message">
                    <Typography variant="body1">Please reach out to the merchant to request access to them</Typography>
                </LocalizedStrict>
            </DialogContent>
        </StandardDialog>
    )
}
